import PointAndClickScene from "@/models/PointAndClickScene";
import PointAndClickItem from "@/models/PointAndClickItem";
import PointAndClickCharacter from "@/models/PointAndClickCharacter";
import {
    AlarmSystem,
    Chair,
    FootballScarf,
    HospitalBed,
    LukasCellphone
} from "@/assets/data/items/collection_items-ZORO-002";
import { Blink } from "@/assets/data/animations/animations";

const bgPosDeltaX = 180;
const bgPosDeltaY = 180;

export const Zoro002IntroHospitalRoomTalkRecipientScene = new PointAndClickScene({

    id: 'zoro-002-intro-hospital_room_talk_recipient_scene',
    startLocation: 'room',
    showPhoneButton: false,
    locations: {
        'room': {
            items: [
                new PointAndClickItem({
                    id: 'bg',
                    img: require('@/assets/images/scenes/zoro002/bg_hospitalroom.png'),
                    pos: { left: -bgPosDeltaX, top: -bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: 'tv',
                    img: require('@/assets/images/scenes/zoro002/objects/_general/tv_footbal.png'),
                    pos: { left: 1812 - bgPosDeltaX, top: 223 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: HospitalBed.id,
                    img: HospitalBed.img,
                    pos: { left: 979 - bgPosDeltaX, top: 623 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: 'soda',
                    img: require('@/assets/images/scenes/zoro002/objects/_general/can_soda.png'),
                    pos: { left: 899 - bgPosDeltaX, top: 785 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: 'room-cart',
                    img: require('@/assets/images/scenes/zoro002/objects/_general/roomcart.png'),
                    pos: { left: 742 - bgPosDeltaX, top: 827 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: AlarmSystem.id,
                    img: AlarmSystem.img,
                    pos: { left: 977 - bgPosDeltaX, top: 718 - bgPosDeltaY },
                    layer: 2
                }),
                new PointAndClickItem({
                    id: LukasCellphone.id,
                    img: LukasCellphone.img,
                    pos: { left: 1300 - bgPosDeltaX, top: 815 - bgPosDeltaY },
                    layer: 2
                }),
                new PointAndClickItem({
                    id: FootballScarf.id,
                    img: FootballScarf.img,
                    pos: { left: 971 - bgPosDeltaX, top: 883 - bgPosDeltaY },
                    layer: 2
                }),
                new PointAndClickItem({
                    id: Chair.id,
                    img: Chair.img,
                    pos: { left: 86 - bgPosDeltaX, top: 942 - bgPosDeltaY },
                    layer: 2
                })
            ],
                characters: [
                    new PointAndClickCharacter({
                        id: 'lukas',
                        layer: 5,
                        imgElements: [
                            {
                                id: 'lukas_bg',
                                img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_body.png'),
                                pos: { left: 600, top: 160 },
                                frames: [
                                    {
                                        id: 'lukas',
                                        img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_body.png')
                                    }
                                ],
                                timing: {
                                    "0": "lukas",
                                }
                            },
                            {
                                id: 'eyes',
                                pos: { left: 998, top: 358 },
                                layer: 2,
                                img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_eo.png'),
                                frames: [
                                    {
                                        id: "open",
                                        img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_eo.png')
                                    },
                                    {
                                        id: "closed",
                                        img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_ec.png')
                                    }
                                ],
                                timing: Blink.timing,
                            },
                            {
                                id: 'mouth',
                                pos: { left: 1031, top: 482 },
                                layer: 2,
                                img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_mc.png'),
                                frames: [
                                    {
                                        id: "closed",
                                        img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_mc.png')
                                    },
                                    {
                                        id: "open",
                                        img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_dialog_mo.png')
                                    }
                                ],
                                timing: [
                                    {
                                        duration: 100,
                                        frameId: "open"
                                    },
                                    {
                                        duration: 100,
                                        frameId: "closed"
                                    },
                                ],
                            }
                        ],
                    }),
                ],
            },

        },

    })
;